import { useState } from "react";
import { InterviewsUIProvider } from "./InterviewsUIContext";
import { InterviewEdit } from "./interview-edit/InterviewEdit";
import { InterviewsCard } from "./InterviewsCard";

export function InterviewsPage({
  preInterviewId
}) {
  const [id, setId] = useState();
  const [showInterviewEdit, setShowInterviewEdit] = useState();
  const closeInterviewEdit = () => setShowInterviewEdit(false);
  
  const interviewsUIEvents = {
    openNewInterviewModal: () => {
      setShowInterviewEdit(true);
    },
    openEditInterviewModal: (id) => {
      setId(id);
      setShowInterviewEdit(true);
    }
  };
  
  return (
    <InterviewsUIProvider preInterviewId={preInterviewId} interviewsUIEvents={interviewsUIEvents}>
      <InterviewEdit
        id={id}
        showInterviewEdit={showInterviewEdit}
        closeInterviewEdit={closeInterviewEdit}
      />
      <InterviewsCard />
    </InterviewsUIProvider>
 );
}